import "rsuite/dist/rsuite.min.css";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";

import AppRouter from "./routes";
import { ToastContainer } from "react-toastify";
import { Loader } from "rsuite";
import AppLogout from "./AppLogout";

function App() {
  document.body.style.zoom = "100%";

  return (
    <div className="App">
      <div id="js-fallback-loader" style={{ display: "none" }}>
        <Loader backdrop vertical size="md" content="Please wait..." />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
      />
      {/* <AppLogout> */}
        <AppRouter />
      {/* </AppLogout> */}
    </div>
  );
}

export default App;
